import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastLeadingIcon,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  toastTitleVariants,
} from "@/components/ui/toast";
import { useToast } from "@/components/ui/use-toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, variant = "default", ...props }) => (
        <Toast key={id} variant={variant} {...props}>
          <div className="flex min-w-0 flex-1 items-start gap-3">
            <ToastLeadingIcon variant={variant} />
            <div className="grid min-w-0 flex-1 gap-1 pt-0.5">
              {title && <ToastTitle className={toastTitleVariants()}>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
          </div>
          {action}
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}
